export default __webpack_public_path__ + "static/media/connected_world.22df95c0.svg";